import ProfitAndLossTypes from './profit-and-loss.types';

/* ********************** GET PROFIT AND LOSS START ***********************/
export const getProfitAndLossStart = (gddData: any) => ({
	type: ProfitAndLossTypes.GET_PROFIT_AND_LOSS_START,
	payload: gddData,
});
export const getProfitAndLossSuccess = (successData: any) => ({
	type: ProfitAndLossTypes.GET_PROFIT_AND_LOSS_SUCCESS,
	payload: successData,
});
export const getProfitAndLossFailure = (failureData: any) => ({
	type: ProfitAndLossTypes.GET_PROFIT_AND_LOSS_FAILURE,
	payload: failureData,
});
export const getProfitAndLossResponceReset = () => ({
	type: ProfitAndLossTypes.GET_PROFIT_AND_LOSS_RESPONSE_RESET,
});
export const getProfitAndLossResponceChanged = () => ({
	type: ProfitAndLossTypes.GET_PROFIT_AND_LOSS_RESPONSE_CHANGED,
});
/* ********************** GET PROFIT AND LOSS END ***********************/
